// @flow
import $ from 'jquery';
import JQueryView, { on } from '../common/JQueryView';
import { fixHeaderTab } from '../../utils/fixHeader';

export default class ShowView extends JQueryView {
  constructor() {
    super('.corporates');
    const breakPoint = $('.corporate-tab-field').offset().top;
    const tabField = 'corporate-tab-field';
    const tabUnderField = 'corporate-show-body';

    $(window).on('load scroll', () => {
      fixHeaderTab(breakPoint, tabField, tabUnderField);
    });
  }

  @on({ event: 'click', selector: 'tr[data-href], li[data-href]' })
  click(e: any) {
    window.open($(e.currentTarget).data('href'), '_blank');
  }

  @on({ event: 'click', selector: '.company-profile-link' })
  clickCompanyProfileLink(e: any) {
    e.preventDefault();
    $('.tab-link')
      .filter('.active')
      .removeClass('active');
    $('.company-profile-link').addClass('active');
    $('html, body').animate(
      {
        scrollTop: this.heightForScroll($('#company-profile-section')),
      },
      1000,
    );
  }

  @on({ event: 'click', selector: '.stockholder-link' })
  clickStockholderLink(e: any) {
    e.preventDefault();
    $('.tab-link')
      .filter('.active')
      .removeClass('active');
    $('.stockholder-link').addClass('active');
    $('html, body').animate(
      {
        scrollTop: this.heightForScroll($('#stockholder-section')),
      },
      1000,
    );
  }

  @on({ event: 'click', selector: '.funding-link' })
  clickFundingLink(e: any) {
    e.preventDefault();
    $('.tab-link')
      .filter('.active')
      .removeClass('active');
    $('.funding-link').addClass('active');
    $('html, body').animate(
      {
        scrollTop: this.heightForScroll($('#funding-section')),
      },
      1000,
    );
  }

  heightForScroll(target: any) {
    const headerHeight =
      $('.header').outerHeight() + $('.corporate-tab-field').outerHeight();
    return target.offset().top - headerHeight - 10;
  }
}
